import type { paths } from '@luxuryescapes/contract-trip'
import request from 'api/requestUtils'
import { baseUri, getOptions } from './utils'

export type TranscribeAudioParams = {
  audio: Blob
  filename?: string
  accessToken?: string
}

type TranscribeAudioApiResponse =
  paths['/api/trips/v2/transcribe']['post']['responses']['200']['content']['application/json']

export type TranscribeAudioResponse = TranscribeAudioApiResponse['result']

export async function transcribeAudio({
  audio,
  filename = 'recording.webm',
  accessToken,
}: TranscribeAudioParams): Promise<TranscribeAudioResponse> {
  const formData = new FormData()
  formData.append('file', audio, filename)

  const response = await request.post<TranscribeAudioApiResponse, FormData>(
    `${baseUri}/v2/transcribe`,
    formData,
    getOptions(accessToken),
  )

  return response.result
}
